// extracted by mini-css-extract-plugin
export var arrow = "SelectedTaxonomiesList-module--arrow--eb41d";
export var arrowNo = "SelectedTaxonomiesList-module--arrow_no--28645";
export var arrowYes = "SelectedTaxonomiesList-module--arrow_yes--54cc9";
export var flex = "SelectedTaxonomiesList-module--flex--b1458";
export var flex1 = "SelectedTaxonomiesList-module--flex_1--8ec99";
export var flexCenter = "SelectedTaxonomiesList-module--flex_center--c316a";
export var flexCenterCol = "SelectedTaxonomiesList-module--flex_center_col--111eb";
export var flexCol = "SelectedTaxonomiesList-module--flex_col--ac797";
export var flexFixCenterCol = "SelectedTaxonomiesList-module--flex_fix_center_col--059e1";
export var flexFixedCenterCol = "SelectedTaxonomiesList-module--flex_fixed_center_col--3612e";
export var rotating = "SelectedTaxonomiesList-module--rotating--0f81e";
export var selectedItemsContainer = "SelectedTaxonomiesList-module--selectedItemsContainer--be63b";